import KpiConverter from "./KpiConverter";
import * as IpProtocol from "./enums/IpProtocolEnum";
import * as Bearer from "./enums/BearerEnum";
import * as Netstat from "./enums/NetstatEnum";
import * as SimState from "./enums/SimStateEnum";
import * as WifiStatus from "./enums/WifiStatusEnum";

export default class HuaweiE580KpiConverter extends KpiConverter {
    /**
     * Constructor
     *
     * @param brand
     * @param ip
     */
    constructor(brand, ip) {
        super(brand, ip);
    }

    /**
     * Removed special XML characters
     *
     * @param inputString
     * @returns {string|XML}
     */
    static removeParasaticalCharacters(inputString) {
        //case seen on real router: value returned for RSSI is '&amp;gt;=-51dBm' => clean this value
        return inputString ? inputString.toString().replace('&gt;=', '').replace('&lt;=', '').replace('&amp;', '').replace('&gt;', '').replace('=', '').replace(';', '').replace('>', '').replace('<', '') : '';
    }

    /**
     * Remove all characters ([azAZ]) from string and convert to int
     *
     * @param inputString An input string
     */
    static removeAllCharsAndConvertToInt(inputString) {
        return inputString ? parseInt(inputString.toString().toLowerCase().replace(/[a-zA-Z]+/g, '')) : '';
    }

    /**
     * Check if value exists
     * @param value
     * @returns {boolean}
     */
    static isNotNull(value) {
        return value !== undefined && value !== null;
    }

    /**
     * Set api retrieval time
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    apiRetrievalTime(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.retrievalTime)) {
            rawKpi[super.getRawKpiConstants().API_RETRIEVAL_TIME] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.retrievalTime));
        }
    }

    /**
     * Set api local IP
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    localIp(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.localIp)) {
            rawKpi[super.getRawKpiConstants().LOCAL_IP] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.localIp);
        }
    }

    /**
     * Set api local ip protocol
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    localIpProtocol(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.localIp)) {
            rawKpi[super.getRawKpiConstants().LOCAL_IP_PROTOCOL] = IpProtocol.VERSION_4;
        }
    }

    /**
     * Set api WAN ip
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wanIp(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPv6Address)) {
            rawKpi[super.getRawKpiConstants().WAN_IP] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WanIPv6Address);
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPAddress)) {
            rawKpi[super.getRawKpiConstants().WAN_IP] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WanIPAddress);
        }
    }

    /**
     * Set api WAN ip protocol
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wanIpProtocol(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPv6Address)) {
            rawKpi[super.getRawKpiConstants().WAN_IP_PROTOCOL] = IpProtocol.VERSION_6;
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.WanIPAddress)) {
            rawKpi[super.getRawKpiConstants().WAN_IP_PROTOCOL] = IpProtocol.VERSION_4;
        } else {
            rawKpi[super.getRawKpiConstants().WAN_IP_PROTOCOL] = IpProtocol.UNSUPPORTED;
        }
    }

    /**
     * Set api model
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    model(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.DeviceName)) {
            rawKpi[super.getRawKpiConstants().MODEL] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.DeviceName);
        }
    }

    /**
     * Set api serial number
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    serialNumber(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.SerialNumber)) {
            rawKpi[super.getRawKpiConstants().SERIAL_NUMBER] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SerialNumber);
        }
    }

    /**
     * Set api IMEI
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    imei(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.Imei)) {
            rawKpi[super.getRawKpiConstants().IMEI] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Imei);
        }
    }

    /**
     * Set api IMSI
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    imsi(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.Imsi)) {
            rawKpi[super.getRawKpiConstants().IMSI] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Imsi);
        }
    }

    /**
     * Set api ICCID
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    iccid(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.Iccid)) {
            rawKpi[super.getRawKpiConstants().ICCID] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Iccid);
        }
    }

    /**
     * Set api MSISDN
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    msisdn(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.Msisdn)) {
            rawKpi[super.getRawKpiConstants().MSISDN] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Msisdn);
        }
    }

    /**
     * Set api hardware version
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    hardwareVersion(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.HardwareVersion)) {
            rawKpi[super.getRawKpiConstants().HARDWARE_VERSION] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.HardwareVersion);
        }
    }

    /**
     * Set api software version
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    softwareVersion(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.SoftwareVersion)) {
            rawKpi[super.getRawKpiConstants().SOFTWARE_VERSION] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SoftwareVersion);
        }
    }

    /**
     * Set api bearer
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    bearer(rawData, rawKpi) {
        // Mapping
        const HUAWEI_NETWORK_TYPES = {
            "0": Bearer.UNKNOWN,
            "1": Bearer.TYPE_2G,
            "2": Bearer.TYPE_2G,
            "3": Bearer.TYPE_2G,
            "4": Bearer.TYPE_3G,
            "5": Bearer.TYPE_3G,
            "6": Bearer.TYPE_3G,
            "7": Bearer.TYPE_3G,
            "8": Bearer.TYPE_3G,
            "9": Bearer.HSDPA, // 3G+
            "10": Bearer.TYPE_3G,
            "11": Bearer.TYPE_3G,
            "12": Bearer.TYPE_3G,
            "13": Bearer.TYPE_3G,
            "14": Bearer.TYPE_3G,
            "15": Bearer.TYPE_3G,
            "16": Bearer.TYPE_3G,
            "17": Bearer.HSDPA, // 3G+
            "18": Bearer.HSDPA, // 3G+
            "19": Bearer.TYPE_4G,
            "21": Bearer.CDMA,
            "22": Bearer.CDMA,
            "23": Bearer.CDMA,
            "24": Bearer.CDMA,
            "25": Bearer.CDMA,
            "26": Bearer.CDMA,
            "27": Bearer.CDMA,
            "28": Bearer.CDMA,
            "29": Bearer.CDMA,
            "30": Bearer.CDMA,
            "31": Bearer.EHRPD,
            "32": Bearer.EHRPD,
            "33": Bearer.EHRPD,
            "34": Bearer.EHRPD,
            "35": Bearer.EHRPD,
            "36": Bearer.EHRPD,
            "41": Bearer.TYPE_3G, //WDCDMA
            "42": Bearer.TYPE_3G,
            "43": Bearer.TYPE_3G,
            "44": Bearer.TYPE_3G,
            "45": Bearer.HSDPA, // 3G+
            "46": Bearer.HSDPA, // 3G+
            "61": Bearer.CDMA,
            "62": Bearer.TYPE_3G,
            "63": Bearer.TYPE_3G,
            "64": Bearer.TYPE_3G,
            "65": Bearer.HSDPA, // 3G+
            "81": Bearer.IWLAN, // WIMAX
            "101": Bearer.TYPE_4G
        };


        if (HuaweiE580KpiConverter.isNotNull(rawData.CurrentNetworkType)) {
            rawKpi[super.getRawKpiConstants().BEARER] = HUAWEI_NETWORK_TYPES[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.CurrentNetworkType)] ? HUAWEI_NETWORK_TYPES[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.CurrentNetworkType)] : Bearer.UNSUPPORTED;
        } else {
            rawKpi[super.getRawKpiConstants().BEARER] = Bearer.UNKNOWN;
        }
    }

    /**
     * Set api netstat
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    netstat(rawData, rawKpi) {
        // Mapping
        const HUAWEI_NETSTAT = {
            "900": Netstat.SEARCHING,
            "901": Netstat.HOME_NETWORK,
            "902": Netstat.NO_SERVICE,
            "903": Netstat.NO_SERVICE
        };

        /*var MACRO_CONNECTION_CONNECTING = '900';
         var MACRO_CONNECTION_CONNECTED = '901';
         var MACRO_CONNECTION_DISCONNECTED = '902';
         var MACRO_CONNECTION_DISCONNECTING = '903';*/

        if (HuaweiE580KpiConverter.isNotNull(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.workmode)) && HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.workmode) === "NO SERVICE") {
            rawKpi[super.getRawKpiConstants().NETSTAT] = Netstat.NO_SERVICE;
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.RoamingStatus) && parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.RoamingStatus)) > 0) {
            rawKpi[super.getRawKpiConstants().NETSTAT] = Netstat.ROAMING_NATIONAL;
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.ConnectionStatus) && parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ConnectionStatus)) === 105) {
            rawKpi[super.getRawKpiConstants().NETSTAT] = Netstat.AIRPLANE;
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.ConnectionStatus)) {
            rawKpi[super.getRawKpiConstants().NETSTAT] = HUAWEI_NETSTAT[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ConnectionStatus)] ? HUAWEI_NETSTAT[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ConnectionStatus)] : Netstat.UNKNOWN;
        } else {
            rawKpi[super.getRawKpiConstants().NETSTAT] = Netstat.UNKNOWN;
        }
    }

    /**
     * Set api sim status
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    simStatus(rawData, rawKpi) {
        // Mapping
        const HUAWEI_SIM_STATUS = {
            "0": SimState.PIN_REQUIRE,
            "1": SimState.READY,
            "255": SimState.ABSENT,
            "256": SimState.NETWORK_LOCKED,
            "257": SimState.READY,
            "258": SimState.READY,
            "259": SimState.PIN_REQUIRE,
            "260": SimState.PIN_REQUIRE,
            "261": SimState.PUK_REQUIRE
        };

        /*var MACRO_NO_SIM_CARD = '255';
         var MACRO_CPIN_FAIL = '256';
         var MACRO_PIN_READY = '257';
         var MACRO_PIN_DISABLE = '258';
         var MACRO_PIN_VALIDATE = '259';
         var MACRO_PIN_REQUIRED = '260';
         var MACRO_PUK_REQUIRED = '261';*/

        if (HuaweiE580KpiConverter.isNotNull(rawData.SimStatus)) {
            rawKpi[super.getRawKpiConstants().SIM_STATUS] = HUAWEI_SIM_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SimStatus)] ? HUAWEI_SIM_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.SimStatus)] : SimState.UNKNOWN;
        } else {
            rawKpi[super.getRawKpiConstants().SIM_STATUS] = SimState.UNKNOWN;
        }
    }

    /**
     * Set api wifi users
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wifiUsers(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.CurrentWifiUser)) {
            rawKpi[super.getRawKpiConstants().WIFI_USERS] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.CurrentWifiUser));
        }
    }

    /**
     * Set api wifi status
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wifiStatus(rawData, rawKpi) {
        // Mapping
        const HUAWEI_WIFI_STATUS = {
            "0": WifiStatus.DISCONNECTED,
            "1": WifiStatus.CONNECTED,
            "2": WifiStatus.CONNECTED,
            "3": WifiStatus.DISCONNECTED,
            "900": WifiStatus.SEARCHING,
            "901": WifiStatus.CONNECTED,
            "902": WifiStatus.DISCONNECTED,
            "903": WifiStatus.DISCONNECTED
        };

        /*
         var WIFI_CONNECTING = '900';
         var WIFI_CONNECTED= '901';
         var WIFI_DISCONNECTED = '902';
         var WIFI_DISCONNECTING = '903';
         */

        if (HuaweiE580KpiConverter.isNotNull(rawData.WifiConnectionStatus)) {
            rawKpi[super.getRawKpiConstants().WIFI_STATUS] = HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiConnectionStatus)] ? HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiConnectionStatus)] : WifiStatus.UNKNOWN;
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.WifiStatus)) {
            rawKpi[super.getRawKpiConstants().WIFI_STATUS] = HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiStatus)] ? HUAWEI_WIFI_STATUS[HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiStatus)] : WifiStatus.UNKNOWN;
        } else {
            rawKpi[super.getRawKpiConstants().WIFI_STATUS] = WifiStatus.UNKNOWN;
        }
    }

    /**
     * Set api wifi ssid
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wifiSsid(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.WifiSsid)) {
            rawKpi[super.getRawKpiConstants().WIFI_SSID] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiSsid);
        }
    }

    /**
     * Set api wifi channel
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wifiChannel(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.WifiChannel)) {
            rawKpi[super.getRawKpiConstants().WIFI_CHANNEL] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.WifiChannel));
        }
    }

    /**
     * Set api wifi bandwidth
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    wifiBandwidth(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.wifibandwidth)) {
            rawKpi[super.getRawKpiConstants().WIFI_BANDWIDTH] = parseInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.wifibandwidth));
        }
    }

    /**
     * Set api pci
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    pci(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.pci)) {
            rawKpi[super.getRawKpiConstants().PCI] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.pci));
        }
    }

    /**
     * Set api psc
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    psc(rawData, rawKpi) {

        if (HuaweiE580KpiConverter.isNotNull(rawData.psc)) {
            rawKpi[super.getRawKpiConstants().PSC] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.psc));
        }
    }

    /**
     * Set api cell id
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    cellId(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.cell_id)) {
            rawKpi[super.getRawKpiConstants().CELL_ID] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.cell_id));
            super.cellId(rawData, rawKpi);
        }
    }

    /**
     * Set api LAC / TAC
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    lac(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.lac)) {
            rawKpi[super.getRawKpiConstants().LAC] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(rawData.lac);
        } else if (HuaweiE580KpiConverter.isNotNull(rawData.tac)) {
            rawKpi[super.getRawKpiConstants().LAC] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(rawData.tac);
        }
    }

    /**
     * Set api rsrq
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    rsrq(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.rsrq)) {
            rawKpi[super.getRawKpiConstants().RSRQ] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rsrq));
        }
    }

    /**
     * Set api rsrp
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    rsrp(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.rsrp)) {
            rawKpi[super.getRawKpiConstants().RSRP] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rsrp));
        }
    }

    /**
     * Set api rssi
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    rssi(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.rssi)) {
            rawKpi[super.getRawKpiConstants().RSSI] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rssi));
        }
    }

    /**
     * Set api snr
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    snr(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.sinr)) {
            rawKpi[super.getRawKpiConstants().SNR] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.sinr));
        }
    }

    /**
     * Set api rscp
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    rscp(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.rscp)) {
            rawKpi[super.getRawKpiConstants().RSCP] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.rscp));
        }
    }

    /**
     * Set api ecno
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    ecno(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.ecio)) {
            rawKpi[super.getRawKpiConstants().ECNO] = HuaweiE580KpiConverter.removeAllCharsAndConvertToInt(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.ecio));
        }
    }

    /**
     * Set api mcc
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    mcc(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.Numeric) && rawData.Numeric.length > 2) {
            rawKpi[super.getRawKpiConstants().MCC] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Numeric).substr(0,3);
        }
    }

    /**
     * Set api mnc
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    mnc(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.Numeric) && rawData.Numeric.length > 3) {
            rawKpi[super.getRawKpiConstants().MNC] = HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Numeric).substr(3, HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.Numeric).length - 3);
        }
    }

    /**
     * Set earfcn
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    earfcn(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.earfcn)) {
            const regex = /DL:([0-9]*) /gmi;
            const res = regex.exec(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.earfcn));
            if (res && res.length === 2) {
                rawKpi[super.getRawKpiConstants().EARFCN] = parseInt(res[1]);
            }
        }
    }

    /**
     * Set DL bandwidth
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    dlbandwidth(rawData, rawKpi) {
        if (HuaweiE580KpiConverter.isNotNull(rawData.dlbandwidth)) {
            const regex = /([0-9]*)Mhz/gmi;
            const res = regex.exec(HuaweiE580KpiConverter.removeParasaticalCharacters(rawData.dlbandwidth));
            if (res && res.length === 2) {
                rawKpi[super.getRawKpiConstants().DL_BANDWIDTH] = parseInt(res[1]);
            }
        }
    }

    /**
     * Set api rad band
     *
     * @param rawData Input
     * @param rawKpi Output
     */
    radBand(rawData, rawKpi) {
        super.radBand(rawData, rawKpi);
    }

    /**
     * Convert a raw data to a raw kpi
     *
     * @param rawData
     * @returns {Promise}
     */
    convert(rawData) {
        return super.convert(rawData, [
            this.localIp,
            this.apiRetrievalTime,
            this.localIpProtocol,
            this.wanIp,
            this.wanIpProtocol,
            this.model,
            this.serialNumber,
            this.imei,
            this.imsi,
            this.iccid,
            this.msisdn,
            this.hardwareVersion,
            this.softwareVersion,
            this.bearer,
            this.netstat,
            this.simStatus,
            this.wifiUsers,
            this.wifiStatus,
            this.wifiSsid,
            this.wifiChannel,
            this.wifiBandwidth,
            this.pci,
            this.cellId,
            this.rsrq,
            this.rsrp,
            this.rssi,
            this.snr,
            this.rscp,
            this.mcc,
            this.mnc,
            this.lac,
            this.earfcn,
            this.dlbandwidth,
            this.radBand
        ]);
    }
}


// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/converter/HuaweiKpiConverter.js